import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuthReducer from '../auth.reducer';
import * as fromForgotPasscodeLoginConfirmReducer from '../reducers/forgot-passcode-login-confirm.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region VALIDATE GOV ID AND PASSPORT NUMBER SUB STATE
export const getForgotPasscodeLoginConfirmState = createSelector(
  getAuthState,
  state => state[fromForgotPasscodeLoginConfirmReducer.forgotPasscodeLoginConfirmFeatureKey]
);

export const getForgotPasscodeVerifyIsLoading = createSelector(
  getForgotPasscodeLoginConfirmState,
  fromForgotPasscodeLoginConfirmReducer.getForgotPasscodeLoginConfirmIsLoading
);

export const getForgotPasscodeVerifyRequest = createSelector(
  getForgotPasscodeLoginConfirmState,
  fromForgotPasscodeLoginConfirmReducer.getForgotPasscodeLoginConfirmRequest
);

export const getForgotPasscodeVerifyResponse = createSelector(
  getForgotPasscodeLoginConfirmState,
  fromForgotPasscodeLoginConfirmReducer.getForgotPasscodeLoginConfirmResponse
);

export const getForgotPasscodeVerifyFailure = createSelector(
  getForgotPasscodeLoginConfirmState,
  fromForgotPasscodeLoginConfirmReducer.getForgotPasscodeLoginConfirmFailure
);
